import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueMemberPartedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const queueMemberParted: CaseReducer<NinchatState> = (state, action) => {
    const {
        event_cause, // eslint-disable-line @typescript-eslint/no-unused-vars
        queue_id,
        user_id,
        ...rest
    } = extractProperties<NinchatQueueMemberPartedEvent>(action.payload)

    isEmpty(rest)

    if (state.user_queues?.[queue_id]) {
        // When someone is removed from one of my queues
        delete state.user_queues?.[queue_id]?.queue_members?.[user_id]
    } else if (state._queues?.[queue_id]) {
        // When someone is removed from one of NOT my queues
        delete state._queues?.[queue_id]?.queue_members?.[user_id]
    }
}
